import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils } from '@shared/utils';
import styles from './spinner.module.scss';

interface SpinnerProps {
  className?: string;
  dark?: boolean;
  position?: boolean;
  fixed?: boolean;
  text?: string;
}

export const Spinner = (props: SpinnerProps) => {
  const { t } = useTranslation();

  const text = props.text ?? t('spinner.title');
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-1 relative text-white bg-inherit',
        props.position && 'w-full h-full bg-[#00000033] absolute top-1/2 left-1/2 -translate-1/2 z-50',
        props.fixed && 'fixed',
        (props.dark || PaletteUtils.isBordierPalette) && ['text-[#27272b]', styles.dark],
        props.className,
      )}
    >
      <div className={cn('w-[42px] h-[42px]', styles.spinner)} />
      <div>{text}</div>
    </div>
  );
};
